var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree"},[_c('node-tree',{attrs:{"node":_vm.treeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }